import React, { useState } from 'react';
import { Send } from 'lucide-react';

interface InputAreaProps {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onKeyPress: (e: React.KeyboardEvent) => void;
    onSend: () => void;
    disabled?: boolean;
    isConnected?: boolean;
}

const InputArea: React.FC<InputAreaProps> = ({
                                                 value,
                                                 onChange,
                                                 onKeyPress,
                                                 onSend,
                                                 disabled = false,
                                                 isConnected = true
                                             }) => {
    const [isFocused, setIsFocused] = useState(false);
    return (
        <div className="container mx-auto">
            <div className="max-w-2xl mx-auto">
                {!isConnected && (
                    <div className="flex items-center mb-2 text-xs text-red-600">
                        <div className="h-2 w-2 bg-red-600 rounded-full mr-2 animate-pulse"></div>
                        Connecting to AI service...
                    </div>
                )}
                <div className={`relative flex items-center transition-all duration-200 ${isFocused ? 'transform scale-[1.02]' : ''}`}>
                    <input
                        type="text"
                        placeholder={!isConnected ? "Connecting to AI service..." : disabled ? "Waiting for the answer..." : "Ask me anything about your Xelacore data"}
                        className={`w-full pl-6 pr-16 py-4 rounded-full border ${
                            isFocused ? 'border-blue-400 ring-2 ring-blue-100' : 'border-gray-200'
                        } shadow-sm ${
                            disabled ? 'bg-gray-100' : 'bg-white'
                        } focus:outline-none transition-all duration-200`}
                        value={value}
                        onChange={onChange}
                        onKeyPress={onKeyPress}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        disabled={disabled || !isConnected}
                    />
                    <button
                        className={`absolute right-2 p-3 rounded-full ${
                            disabled || !isConnected
                                ? 'bg-gray-300 cursor-not-allowed'
                                : isFocused 
                                  ? 'bg-blue-500 hover:bg-blue-700 cursor-pointer transform scale-110'
                                  : 'bg-blue-600 hover:bg-blue-700 cursor-pointer'
                        } text-white transition-all duration-200`}
                        onClick={onSend}
                        disabled={disabled || !isConnected}
                        aria-label={disabled ? "Waiting for response" : "Send message"}
                    >
                        <Send size={18} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InputArea;